import { CookieType } from "@/shared/composables/wecoma/use-wecoma-integration";
import eventBus from "@/shared/utils/event-bus";
import { GlobalEvents } from "@/shared/model/enums/global-events";
import Cookies from "js-cookie";
import { useCookieStorage, useLocalStorage, useSessionStorage } from "@/shared/composables/use-storage";
import { useWebStorageTest } from "@/shared/composables/web-storage/use-web-storage-test";
import { WebStorageType } from "@/shared/model/web-storage-type";

type QueueItemType = {
    itemName: string;
    value: string;
    storageType: WebStorageType | "cookie";
    cookieType: CookieType;
    cookieAttributes?: Cookies.CookieAttributes;
};

// items in memory queue waiting for consent
const storageQueue: QueueItemType[] = [];

eventBus.on(GlobalEvents.ConsentsChanged, () => processStorageQueue());

function processStorageQueue() {
    const cookieStorage = useCookieStorage();
    const localStorage = useLocalStorage();
    const sessionStorage = useSessionStorage();
    storageQueue.forEach((item) => {
        if (useWebStorageTest().canSetValue(item.cookieType)) {
            switch (item.storageType) {
                case "cookie":
                    cookieStorage.setItem(item.itemName, item.value, item.cookieType, item.cookieAttributes);
                    break;
                case "localStorage":
                    localStorage.setItem(item.itemName, item.value, item.cookieType);
                    break;
                case "sessionStorage":
                    sessionStorage.setItem(item.itemName, item.value, item.cookieType);
                    break;
            }
        }
    });
}

export const useWebStorageQueue = () => {
    const enqueue = (item: QueueItemType) => {
        storageQueue.push(item);
    };

    return {
        enqueue,
    };
};
